import { useQuery } from "@tanstack/react-query"

import { getEstadisticas } from "../services/estadisticas";

export const useEstadisticas = ({ periodo, desde, hasta }) => {

    const estadisticasQuery = useQuery({
        queryKey: ['estadisticas', { periodo, desde, hasta }],
        queryFn: () => getEstadisticas(periodo, desde, hasta),
        staleTime: 1000 * 60 * 60, // 1 hora
        placeholderData: {
            desde: '',
            hasta: '',
            data: {
                contadores: {
                    consultasContador: 0,
                    consultasSubsecuentesContador: 0,
                    consultasPrimeraVezContador: 0,
                    pruebasDeAlergiaContador: 0,
                    pruebasDeAlergiaPositivasContador: 0,
                    pruebasDeAlergiaNegativasContador: 0,
                    inmunoterapiasContador: 0,
                    inmunoterapiaSubcutaneaContador: 0,
                    inmunoterapiaSublingualContador: 0,
                    alxoidContador: 0,
                    oraltekContador: 0,
                    inmunoterapiaDeInicioContador: 0,
                    inmunoterapiasTerminadasContador: 0,
                    inmunoterapiasInconclusasContador: 0,
                    instagram: 0,
                    facebook: 0,
                    tiktok: 0,
                    paginaWeb: 0,
                    referenciaOtroDoctor: 0,
                    referenciaFamiliar: 0,
                    referenciaAmistad: 0,
                    centroMEdicoHospital: 0,
                    otro: 0,
                    noEspecificado: 0
                },
                grafica: []
            }
        }
    });

    return {
        estadisticasQuery,
    }
}